@if (isImpersonating()) {
  <div class="impersonation-banner" role="alert">
    <mat-icon fontSet="fa" fontIcon="fa-user-secret"></mat-icon>
    <span class="impersonation-banner__message">
      Impersonating — initiated by <strong>{{ impersonation()?.impersonatedBy }}</strong>
    </span>
    <button mat-stroked-button class="impersonation-banner__exit" (click)="exit()">
      Exit impersonation
    </button>
  </div>
}
